import { render, staticRenderFns } from "./HouseFundWithdrawalInfo.vue?vue&type=template&id=0c6010f2&"
import script from "./HouseFundWithdrawalInfo.vue?vue&type=script&lang=js&"
export * from "./HouseFundWithdrawalInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports